import { Injectable } from '@angular/core';
import {VesselService} from "./vessel.service";

@Injectable()
export class VesselContextService {
  private vesselId: number = null;

  constructor(private vesselService: VesselService) {}

  async init() {
    const editor = await this.vesselService.getEditor();
    this.vesselId = editor && editor.id ? editor.id : null;
  }

  setVesselId(id: number) {
    this.vesselId = id;
  }

  getVesselId(): number {
    return this.vesselId;
  }
}



// WEBPACK FOOTER //
// ./src/services/vessel/vessel-context.service.ts